import { Link } from 'react-router-dom';
import {
  NOT_AVAILABLE_UPPERCASE,
  STRATEGY_STATUS_DRAFT
} from '../../shared/AppConstants';
import {
  formatAmountWithCommas,
  getUnitGropAndUnitsList,
  isScopeAnyGlobalType,
  paintMGCs
} from '../../shared/UtilFunctions';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { getLinkUri } from '../StrategyUtils';
import { PhaseAndStatusBadge } from '../Strategy/PhaseAndStatusBadge';

export default function StrategyCard(props) {
  let { strategy, owner, masterMGCs, userInfo } = props;
  let { scope } = strategy;
  const linkUri = getLinkUri(
    strategy,
    userInfo && userInfo.userId.toUpperCase(),
    userInfo && userInfo.isAdmin,
    userInfo && userInfo.hasCreateAccess
  );

  let utilization =
    strategy.utilization !== undefined &&
    strategy.utilization !== null &&
    !isNaN(strategy.utilization)
      ? Math.round(strategy.utilization.toFixed(3) * 100) + '%'
      : NOT_AVAILABLE_UPPERCASE;

  return (
    <Card
      variant="outlined"
      sx={(theme) => ({ mb: theme.fuel6Tokens.JddcSpacingMedium })}
    >
      <CardContent
        sx={(theme) => ({
          p: theme.fuel6Tokens.JddcSpacingMedium,
          '&:last-child': { pb: theme.fuel6Tokens.JddcSpacingMedium }
        })}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: 2
          }}
        >
          {/* Left: link + badge, metrics, MGCs */}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                flexWrap: 'wrap',
                mb: 0.5
              }}
            >
              <Link
                to={{
                  pathname: linkUri,
                  state: { masterMGCs: masterMGCs }
                }}
                style={{ textDecoration: 'none', color: 'inherit' }}
              >
                <Typography fontWeight="bold" color="text.theme">
                  Strategy #{strategy.strategyId}
                </Typography>
              </Link>
              <PhaseAndStatusBadge strategy={strategy} />
            </Box>

            {STRATEGY_STATUS_DRAFT !== strategy.status && (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.5,
                  mb: 0.5,
                  flexWrap: 'wrap'
                }}
              >
                <Typography component="span">
                  <Typography component="span" fontWeight="bold">
                    Utilization{' '}
                  </Typography>
                  {utilization}
                </Typography>
                <Typography component="span">
                  <Typography component="span" fontWeight="bold">
                    Strategy Spend{' '}
                  </Typography>
                  {formatAmountWithCommas(
                    strategy.forecastTotalSpend,
                    true,
                    NOT_AVAILABLE_UPPERCASE
                  )}
                </Typography>
              </Box>
            )}

            <Box>{paintMGCs(strategy)}</Box>
          </Box>

          {/* Right: owner + scope */}
          <Box sx={{ textAlign: 'right' }}>
            <Typography sx={{ display: 'block' }}>
              <Typography component="span" fontWeight="bold">
                Owner{' '}
              </Typography>
              <Typography component="span">{owner}</Typography>
            </Typography>
            {isScopeAnyGlobalType(scope.level) ? (
              <Typography color="text.secondary" sx={{ display: 'block' }}>
                {scope.level}
              </Typography>
            ) : (
              strategy.decorated?.scope &&
              getUnitGropAndUnitsList(strategy.decorated.scope)
                .sort()
                .map((s) => (
                  <Typography
                    key={`${strategy.strategyId}-${s}`}
                    color="text.secondary"
                    sx={{ display: 'block' }}
                  >
                    {s}
                  </Typography>
                ))
            )}
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
}
